import { render } from "./Incidence_categories.vue?vue&type=template&id=3be28545"
import script from "./Incidence_categories.vue?vue&type=script&lang=js"
export * from "./Incidence_categories.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__